import React from 'react';
import { T } from '@tolgee/react';

const QuoteOfTheWeek: React.FC = () => {
  return (
    <div className="quote-of-the-week text-center py-2xl">
      <h3 className="text-primary text-sm mb-4 uppercase">
        <T>home.quote.type.weekly.label</T>
      </h3>
      <p className="text-4xl md:text-6xl px-5 md:px-0 leading-tight w-full md:w-1/2 m-auto py-4">
        <T>home.quote.current_quote.text</T>
      </p>
      <p className="mt-4 text-base">
        {' '}
        - <T>home.quote.current_quote.author</T>
      </p>
    </div>
  );
};

export default QuoteOfTheWeek;
